import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(() => ({
  mainContentContainer: {
    padding: "15px  ",
  },
}));
